/* MYBOOST Cart Drawer V12 — JS extracted from cart-drawer.liquid */
/* Same behavior, externalized for caching. */

(function() {
  const drawer = document.getElementById('MinimogCartDrawer');
  if (!drawer) return;

  let isUpdating = false;

  const STORAGE_KEY_CODE = 'mb_discount_code';
  const STORAGE_KEY_PERCENT = 'mb_discount_percent';
  const STORAGE_KEY_OPEN = 'mb_cart_should_open';

  // I18N from Liquid
  const i18nEl = document.getElementById('mbCartI18n');
  const I18N = {
    alertLink: i18nEl ? i18nEl.dataset.alertLink : 'Please enter the publication link',
    alertCombo: i18nEl ? i18nEl.dataset.alertCombo : 'This combination is not available',
    defaultUsernameKey: i18nEl ? i18nEl.dataset.defaultUsernameKey : "Nom d'utilisateur",
    propLinkKey: i18nEl ? i18nEl.dataset.propLinkKey : 'Lien de la publication'
  };

  function resetPromoState() {
    localStorage.removeItem(STORAGE_KEY_CODE);
    localStorage.removeItem(STORAGE_KEY_PERCENT);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'discount_code': '' } })
    }).catch(err => console.error('Cart attr reset error:', err));
  }

  function checkAndResetIfEmpty() {
    const cartCount = getCartCount();
    if (cartCount === 0) {
      resetPromoState();
      updatePriceDisplay();
      updatePromoButtonsState();
    }
  }

  let detectedCurrency = '€';
  let currencyPosition = 'after';
  let decimalSeparator = ',';

  function getCartTotal() {
    let total = 0;
    drawer.querySelectorAll('.mb-item').forEach(item => {
      const priceEl = item.querySelector('.mb-item-price');
      if (priceEl) {
        let priceText = priceEl.textContent || '';
        const oldPriceEl = priceEl.querySelector('.mb-item-price-old');
        if (oldPriceEl) priceText = priceText.replace(oldPriceEl.textContent, '').trim();
        detectCurrencyAndFormat(priceText);
        const price = parsePrice(priceText);
        if (price > 0) total += price;
      }
    });
    return total;
  }

  function detectCurrencyAndFormat(priceText) {
    if (!priceText) return;
    const text = priceText.trim();
    const currencyPatterns = [
      { pattern: /Dhs\.?\s*/i, symbol: 'Dhs', position: 'before' },
      { pattern: /AED\s*/i, symbol: 'AED', position: 'before' },
      { pattern: /MAD\s*/i, symbol: 'MAD', position: 'after' },
      { pattern: /د\.إ/i, symbol: 'Dhs', position: 'before' },
      { pattern: /€/, symbol: '€', position: 'after' },
      { pattern: /\$/, symbol: '$', position: 'before' },
      { pattern: /£/, symbol: '£', position: 'before' },
      { pattern: /CHF/i, symbol: 'CHF', position: 'after' },
      { pattern: /CFA/i, symbol: 'CFA', position: 'after' },
      { pattern: /DH\s*/i, symbol: 'DH', position: 'after' },
      { pattern: /SAR/i, symbol: 'SAR', position: 'after' },
    ];
    for (const curr of currencyPatterns) {
      if (curr.pattern.test(text)) {
        detectedCurrency = curr.symbol;
        currencyPosition = curr.position;
        break;
      }
    }
    const numbers = text.match(/\d+[,.]?\d*/g);
    if (numbers && numbers.length > 0) {
      const lastNumber = numbers[numbers.length - 1];
      if (lastNumber.includes(',')) decimalSeparator = ',';
      else if (lastNumber.includes('.')) decimalSeparator = '.';
    }
  }

  function parsePrice(priceText) {
    if (!priceText) return 0;
    let cleaned = priceText
      .replace(/Dhs\.?\s*/gi, '').replace(/AED\s*/gi, '').replace(/MAD\s*/gi, '')
      .replace(/د\.إ\s*/gi, '').replace(/EUR\s*/gi, '').replace(/USD\s*/gi, '')
      .replace(/GBP\s*/gi, '').replace(/CHF\s*/gi, '').replace(/CFA\s*/gi, '')
      .replace(/SAR\s*/gi, '').replace(/[€$£¥₹₺₽₦]/g, '').replace(/DH\s*/gi, '').trim();
    cleaned = cleaned.replace(/[^\d,.\-\s]/g, '').trim().replace(/\s/g, '');
    if (!cleaned) return 0;
    const hasComma = cleaned.includes(',');
    const hasDot = cleaned.includes('.');
    if (hasComma && hasDot) {
      const lastComma = cleaned.lastIndexOf(',');
      const lastDot = cleaned.lastIndexOf('.');
      if (lastComma > lastDot) cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      else cleaned = cleaned.replace(/,/g, '');
    } else if (hasComma) {
      const parts = cleaned.split(',');
      if (parts.length === 2 && parts[1].length <= 2) cleaned = cleaned.replace(',', '.');
      else cleaned = cleaned.replace(/,/g, '');
    }
    const result = parseFloat(cleaned);
    return isNaN(result) ? 0 : result;
  }

  function getCartCount() {
    return parseInt(drawer.dataset.cartCount) || 0;
  }

  function formatPrice(amount) {
    let formatted;
    if (decimalSeparator === ',') formatted = amount.toFixed(2).replace('.', ',');
    else formatted = amount.toFixed(2);
    if (currencyPosition === 'before') return detectedCurrency + ' ' + formatted;
    else return formatted + ' ' + detectedCurrency;
  }

  function updatePriceDisplay() {
    const appliedCode = localStorage.getItem(STORAGE_KEY_CODE);
    const percent = localStorage.getItem(STORAGE_KEY_PERCENT);
    const cartTotal = getCartTotal();
    const cartCount = getCartCount();
    const discountLine = drawer.querySelector('[data-discount-line]');
    const nameEl = drawer.querySelector('[data-discount-line-name]');
    const amountEl = drawer.querySelector('[data-discount-line-amount]');
    const totalEl = drawer.querySelector('[data-total]');
    const totalOldEl = drawer.querySelector('[data-total-old]');

    if (appliedCode && percent && cartCount > 0 && cartTotal > 0) {
      const percentNum = parseInt(percent);
      const savings = cartTotal * percentNum / 100;
      const newTotal = cartTotal - savings;
      if (discountLine) discountLine.classList.add('active');
      if (nameEl) nameEl.textContent = appliedCode;
      if (amountEl) amountEl.textContent = `-${formatPrice(savings)}`;
      if (totalOldEl) { totalOldEl.textContent = formatPrice(cartTotal); totalOldEl.classList.add('active'); }
      if (totalEl) { totalEl.textContent = formatPrice(newTotal); totalEl.classList.add('discounted'); }
    } else {
      if (discountLine) discountLine.classList.remove('active');
      if (totalOldEl) { totalOldEl.textContent = ''; totalOldEl.classList.remove('active'); }
      if (totalEl) { if (cartTotal > 0) totalEl.textContent = formatPrice(cartTotal); totalEl.classList.remove('discounted'); }
    }
  }

  function updatePromoButtonsState() {
    const cartTotal = getCartTotal();
    const cartCount = getCartCount();
    const appliedCode = localStorage.getItem(STORAGE_KEY_CODE);
    let validCodeForCart = appliedCode;
    if (appliedCode) {
      const appliedBtn = drawer.querySelector('.mb-promo-btn[data-code="' + appliedCode + '"]');
      if (appliedBtn) {
        const minAmount = parseFloat(appliedBtn.dataset.min) || 0;
        if (cartTotal < minAmount || cartCount === 0) validCodeForCart = null;
      }
    }
    drawer.querySelectorAll('.mb-promo-btn').forEach(btn => {
      const code = btn.dataset.code;
      const minAmount = parseFloat(btn.dataset.min) || 0;
      btn.classList.remove('checked', 'locked');
      if (cartCount === 0) { btn.classList.add('locked'); return; }
      if (validCodeForCart === code) btn.classList.add('checked');
      else if (cartTotal < minAmount) btn.classList.add('locked');
    });
  }

  function checkAutoOpen() {
    if (localStorage.getItem(STORAGE_KEY_OPEN) === 'true') {
      localStorage.removeItem(STORAGE_KEY_OPEN);
      drawer.classList.add('mb-no-anim');
      drawer.classList.add('mb-open', 'm-cart-drawer--active');
      document.body.style.overflow = 'hidden';
      setTimeout(() => { drawer.classList.remove('mb-no-anim'); }, 50);
      updatePromoButtonsState();
      updatePriceDisplay();
    }
  }

  function initPromos() {
    drawer.querySelectorAll('.mb-promo-btn').forEach(btn => {
      if (btn.hasAttribute('data-promo-bound')) return;
      btn.setAttribute('data-promo-bound', 'true');
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        const code = this.dataset.code;
        const minAmount = parseFloat(this.dataset.min) || 0;
        const percent = this.dataset.percent;
        const cartTotal = getCartTotal();
        const cartCount = getCartCount();
        const currentCode = localStorage.getItem(STORAGE_KEY_CODE);
        if (cartCount === 0) { this.style.animation = 'mb-shake 0.5s ease'; setTimeout(() => this.style.animation = '', 500); return; }
        if (currentCode === code) {
          localStorage.removeItem(STORAGE_KEY_CODE); localStorage.removeItem(STORAGE_KEY_PERCENT);
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'discount_code': '' } }) }).catch(err => console.error(err));
          window.dispatchEvent(new CustomEvent('mb-promo-changed', { detail: { code: null, percent: 0 } }));
          updatePromoButtonsState(); updatePriceDisplay(); return;
        }
        if (cartTotal < minAmount) { this.style.animation = 'mb-shake 0.5s ease'; setTimeout(() => this.style.animation = '', 500); return; }
        showPromoLoading();
        localStorage.setItem(STORAGE_KEY_OPEN, 'true');
        localStorage.setItem(STORAGE_KEY_CODE, code);
        localStorage.setItem(STORAGE_KEY_PERCENT, percent);
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'discount_code': code } }) }).catch(err => console.error(err));
        window.location.href = '/discount/' + code + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
    });
    updatePromoButtonsState();
    updatePriceDisplay();
  }

  drawer.open = function() {
    drawer.classList.remove('mb-open', 'mb-no-anim');
    void drawer.offsetWidth;
    requestAnimationFrame(function() {
      drawer.classList.add('mb-open', 'm-cart-drawer--active');
      document.body.style.overflow = 'hidden';
      checkAndResetIfEmpty(); initPromos();
    });
  };

  drawer.close = function() {
    drawer.classList.remove('mb-open', 'm-cart-drawer--active');
    document.body.style.overflow = '';
  };

  function bindCloseEvents() {
    drawer.querySelectorAll('[data-close], .mb-close, .mb-continue').forEach(el => {
      if (!el.hasAttribute('data-close-bound')) {
        el.setAttribute('data-close-bound', 'true');
        el.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); drawer.close(); });
      }
    });
  }
  bindCloseEvents();
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('mb-open')) drawer.close(); });

  let promoLoadingTimeout = null;
  function showLoading() { drawer.querySelector('[data-loading]').classList.add('active'); isUpdating = true; }
  function hideLoading() { drawer.querySelector('[data-loading]').classList.remove('active'); isUpdating = false; }
  function showPromoLoading() { drawer.querySelector('[data-loading-promo]').classList.add('active'); isUpdating = true; promoLoadingTimeout = setTimeout(() => { hidePromoLoading(); }, 5000); }
  function hidePromoLoading() { if (promoLoadingTimeout) { clearTimeout(promoLoadingTimeout); promoLoadingTimeout = null; } drawer.querySelector('[data-loading-promo]').classList.remove('active'); isUpdating = false; }

  function initCheckoutButton() {
    const checkoutBtn = drawer.querySelector('.mb-checkout');
    if (checkoutBtn && !checkoutBtn.hasAttribute('data-checkout-bound')) {
      checkoutBtn.setAttribute('data-checkout-bound', 'true');
      checkoutBtn.addEventListener('click', async function(e) {
        if (this.disabled) return;
        e.preventDefault(); e.stopPropagation();
        this.classList.add('loading'); this.disabled = true;
        const appliedCode = localStorage.getItem(STORAGE_KEY_CODE);
        try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'discount_code': appliedCode || '' } }) }); } catch (err) {}
        if (appliedCode) window.location.href = '/discount/' + appliedCode + '?redirect=/checkout';
        else window.location.href = '/checkout';
      });
    }
  }

  function updateHeaderCartCount(count) {
    const selectors = ['.m-cart-count', '.cart-count', '[data-cart-count]', '.m-cart-icon__count', '.cart-count-bubble span', '.header__cart-count', '#mbh-cart-count', '#mbh-cart-badge'];
    selectors.forEach(sel => { document.querySelectorAll(sel).forEach(el => { if (!el.closest('#MinimogCartDrawer')) { el.textContent = count; el.style.display = count === 0 ? 'none' : ''; } }); });
  }

  drawer.onCartDrawerUpdate = async function() {
    showLoading();
    try {
      const res = await fetch(window.location.pathname + '?section_id=cart-drawer', { credentials: 'same-origin', cache: 'no-store' });
      if (!res.ok) throw new Error('Fetch failed');
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.getElementById('MinimogCartDrawer');
      if (newDrawer) {
        drawer.dataset.cartTotal = newDrawer.dataset.cartTotal;
        drawer.dataset.cartCount = newDrawer.dataset.cartCount;
        const newCount = parseInt(newDrawer.dataset.cartCount) || 0;
        if (newCount === 0) resetPromoState();
        const newBody = newDrawer.querySelector('[data-items]');
        const curBody = drawer.querySelector('[data-items]');
        if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
        const newHeader = newDrawer.querySelector('.mb-header');
        const curHeader = drawer.querySelector('.mb-header');
        if (newHeader && curHeader) curHeader.innerHTML = newHeader.innerHTML;
        const newCountEl = newDrawer.querySelector('[data-count]');
        const curCountEl = drawer.querySelector('[data-count]');
        if (newCountEl && curCountEl) curCountEl.textContent = newCountEl.textContent;
        const checkoutBtn = drawer.querySelector('.mb-checkout');
        if (checkoutBtn) { checkoutBtn.disabled = newCount === 0; checkoutBtn.classList.remove('loading'); }
        updateHeaderCartCount(newCount);
        bindItemEvents(); bindCloseEvents(); initPromos(); initCheckoutButton();
      }
    } catch (err) { console.error('Cart refresh error:', err); }
    hideLoading();
  };

  async function updateQuantity(line, newQty) {
    if (isUpdating) return; showLoading();
    try { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ line: parseInt(line), quantity: parseInt(newQty) }) }); await drawer.onCartDrawerUpdate(); } catch (err) { console.error(err); hideLoading(); }
  }

  async function updateUsername(item, newUsername) {
    if (isUpdating) return; showLoading();
    const line = parseInt(item.dataset.line);
    const variantId = parseInt(item.dataset.variantId);
    const usernameKey = item.dataset.usernameKey || I18N.defaultUsernameKey;
    const qty = parseInt(item.querySelector('.mb-qty-val').textContent);
    let properties = {};
    const propsStr = item.dataset.props || '';
    if (propsStr) { propsStr.split(';;').forEach(pair => { const [key, val] = pair.split('::'); if (key && val !== undefined) properties[key] = val; }); }
    properties[usernameKey] = newUsername;
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: 0 }) });
      await new Promise(r => setTimeout(r, 300));
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty, properties: properties }) });
      await new Promise(r => setTimeout(r, 200));
      await drawer.onCartDrawerUpdate();
    } catch (err) { console.error(err); hideLoading(); await drawer.onCartDrawerUpdate(); }
  }

  function findVariantId(variantsData, opt1, opt2) {
    const variants = variantsData.split('||');
    for (const v of variants) {
      const parts = v.split('::');
      const vId = parts[0]; const vOpt1 = parts[1] || ''; const vOpt2 = parts[2] || '';
      if (opt2) { if (vOpt1 === opt1 && vOpt2 === opt2) return parseInt(vId); }
      else { if (vOpt1 === opt1) return parseInt(vId); }
    }
    return null;
  }

  async function updateVariant(item, newVariantId) {
    if (isUpdating) return; showLoading();
    const line = parseInt(item.dataset.line);
    const qty = parseInt(item.querySelector('.mb-qty-val').textContent);
    let properties = {};
    const propsStr = item.dataset.props || '';
    if (propsStr) { propsStr.split(';;').forEach(pair => { const [key, val] = pair.split('::'); if (key && val !== undefined) properties[key] = val; }); }
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: 0 }) });
      await new Promise(r => setTimeout(r, 300));
      const addBody = { id: newVariantId, quantity: qty };
      if (Object.keys(properties).length > 0) addBody.properties = properties;
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(addBody) });
      await new Promise(r => setTimeout(r, 200));
      await drawer.onCartDrawerUpdate();
    } catch (err) { console.error(err); hideLoading(); await drawer.onCartDrawerUpdate(); }
  }

  async function addUpsell(upsellItem) {
    if (isUpdating) return;
    const variantId = upsellItem.querySelector('[data-upsell-variant]').value;
    const link = upsellItem.querySelector('[data-upsell-link]').value.trim();
    if (!link) { alert(I18N.alertLink); return; }
    showLoading();
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(variantId), quantity: 1, properties: { [I18N.propLinkKey]: link } }) });
      await new Promise(r => setTimeout(r, 200));
      await drawer.onCartDrawerUpdate();
    } catch (err) { console.error(err); hideLoading(); }
  }

  function bindItemEvents() {
    drawer.querySelectorAll('[data-action="minus"]').forEach(btn => { btn.onclick = function() { if (isUpdating) return; const item = this.closest('[data-line]'); const qty = parseInt(item.querySelector('.mb-qty-val').textContent); if (qty > 1) updateQuantity(item.dataset.line, qty - 1); }; });
    drawer.querySelectorAll('[data-action="plus"]').forEach(btn => { btn.onclick = function() { if (isUpdating) return; const item = this.closest('[data-line]'); const qty = parseInt(item.querySelector('.mb-qty-val').textContent); updateQuantity(item.dataset.line, qty + 1); }; });
    drawer.querySelectorAll('[data-action="remove"]').forEach(btn => { btn.onclick = function() { if (isUpdating) return; updateQuantity(this.closest('[data-line]').dataset.line, 0); }; });
    drawer.querySelectorAll('[data-edit-btn]').forEach(btn => { btn.onclick = function(e) { e.stopPropagation(); if (isUpdating) return; const item = this.closest('[data-line]'); const editRow = item.querySelector('[data-edit-row]'); const input = item.querySelector('[data-edit-input]'); if (editRow && input) { editRow.classList.add('active'); input.focus(); input.select(); } }; });
    drawer.querySelectorAll('[data-edit-cancel]').forEach(btn => { btn.onclick = function(e) { e.stopPropagation(); this.closest('[data-edit-row]').classList.remove('active'); }; });
    drawer.querySelectorAll('[data-edit-save]').forEach(btn => { btn.onclick = function(e) { e.stopPropagation(); if (isUpdating) return; const item = this.closest('[data-line]'); const newUsername = item.querySelector('[data-edit-input]').value.trim().replace(/^@/, ''); if (newUsername) updateUsername(item, newUsername); }; });
    drawer.querySelectorAll('[data-edit-input]').forEach(input => { input.onkeydown = function(e) { if (e.key === 'Enter') { e.preventDefault(); this.closest('[data-line]').querySelector('[data-edit-save]')?.click(); } if (e.key === 'Escape') { e.preventDefault(); this.closest('[data-line]').querySelector('[data-edit-cancel]')?.click(); } }; });
    drawer.querySelectorAll('[data-var-toggle]').forEach(btn => { btn.onclick = function(e) { e.stopPropagation(); if (isUpdating) return; const varContainer = this.closest('.mb-var'); const wasOpen = varContainer.classList.contains('open'); drawer.querySelectorAll('.mb-var').forEach(v => v.classList.remove('open')); if (!wasOpen) varContainer.classList.add('open'); }; });
    drawer.querySelectorAll('.mb-dropdown-item').forEach(btn => { btn.onclick = function(e) { e.stopPropagation(); if (isUpdating) return; const newValue = this.dataset.value; const varContainer = this.closest('.mb-var'); const currentValue = varContainer.dataset.current; varContainer.classList.remove('open'); if (newValue === currentValue) return; const item = this.closest('[data-line]'); const varIndex = parseInt(varContainer.dataset.varIndex); const opt1Container = item.querySelector('[data-var-index="1"]'); const variantsData = opt1Container?.dataset.variants || ''; let opt1 = item.querySelector('[data-var-index="1"]')?.dataset.current || ''; let opt2 = item.querySelector('[data-var-index="2"]')?.dataset.current || ''; if (varIndex === 1) opt1 = newValue; if (varIndex === 2) opt2 = newValue; const newVariantId = findVariantId(variantsData, opt1, opt2); if (newVariantId) updateVariant(item, newVariantId); else alert(I18N.alertCombo); }; });
    drawer.querySelectorAll('[data-upsell-add]').forEach(btn => { btn.onclick = function() { addUpsell(this.closest('.mb-upsell-item')); }; });
  }

  document.addEventListener('click', () => { drawer.querySelectorAll('.mb-var').forEach(v => v.classList.remove('open')); });
  bindItemEvents();

  function interceptCartLinks() {
    const selectors = ['a[href="/cart"]', 'a[href$="/cart"]', '[data-cart-toggle]', '.m-cart-icon', '.header__icon--cart', '#mbh-drawer-cart'];
    selectors.forEach(sel => { document.querySelectorAll(sel).forEach(el => { if (el.closest('#MinimogCartDrawer') || el.dataset.mbCartIntercepted) return; el.dataset.mbCartIntercepted = 'true'; el.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); drawer.open(); }); }); });
  }
  interceptCartLinks();
  new MutationObserver(interceptCartLinks).observe(document.body, { childList: true, subtree: true });

  let lastCartToken = null;
  async function checkCartChanged() {
    if (isUpdating) return;
    try { const res = await fetch('/cart.js', { credentials: 'same-origin' }); const cart = await res.json(); if (lastCartToken !== null && cart.token !== lastCartToken) drawer.onCartDrawerUpdate(); lastCartToken = cart.token; } catch(e) {}
  }
  setInterval(checkCartChanged, 2000);
  checkCartChanged();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        if (drawer.classList.contains('m-cart-drawer--active') && !drawer.classList.contains('mb-open')) {
          void drawer.offsetWidth;
          requestAnimationFrame(function() { drawer.classList.add('mb-open'); document.body.style.overflow = 'hidden'; checkAndResetIfEmpty(); initPromos(); bindCloseEvents(); drawer.onCartDrawerUpdate(); });
        }
      }
    });
  });
  observer.observe(drawer, { attributes: true });

  window.addEventListener('pageshow', function(e) { if (e.persisted) { hidePromoLoading(); hideLoading(); } });
  document.addEventListener('visibilitychange', function() { if (document.visibilityState === 'visible') { const promoLoader = drawer.querySelector('[data-loading-promo]'); if (promoLoader && promoLoader.classList.contains('active')) hidePromoLoading(); } });
  window.addEventListener('storage', function(e) { if (e.key === STORAGE_KEY_CODE || e.key === STORAGE_KEY_PERCENT) { updatePromoButtonsState(); updatePriceDisplay(); } });
  window.addEventListener('mb-promo-changed', function(e) { updatePromoButtonsState(); updatePriceDisplay(); });

  checkAndResetIfEmpty();
  initPromos();
  initCheckoutButton();
  checkAutoOpen();

  console.log('MyBoost Cart V12 Printemps 🌸');
})();
